export enum ResultPageViewMode {
	Results = 'results',
	About = 'about',
}
